import { useEffect, useState } from "react";
import { openModal } from "risa-oasis-ui_v2";
import { getFileDownloadUrl } from "../../../api/firebase/firestoreService";
import { getCmmScreenshotFilePath } from "../../../api/getCalls/getCmmDocuments";
import { AestraPrimaryCareTable } from "../../../data-model/aestraPrimaryCareTable";

export interface UseCmmScreenshotReturn {
  cmmScreenshotDownloadUrl: string | null;
  cmmScreenshotModalOpen: boolean;
  selectedCmmRowData: AestraPrimaryCareTable | null;
  handleViewCmmClick: (rowData: AestraPrimaryCareTable) => Promise<void>;
  closeCmmScreenshotModal: () => void;
  externalLoading: boolean;
}

export const useCmmScreenshot = (): UseCmmScreenshotReturn => {
  const [cmmScreenshotDownloadUrl, setCmmScreenshotDownloadUrl] = useState<
    string | null
  >(null);
  const [cmmScreenshotModalOpen, setCmmScreenshotModalOpen] =
    useState<boolean>(false);
  const [selectedCmmRowData, setSelectedCmmRowData] =
    useState<AestraPrimaryCareTable | null>(null);
  const [externalLoading, setExternalLoading] = useState<boolean>(false);

  useEffect(() => {
    if (cmmScreenshotModalOpen) {
      openModal("doc-viewer-modal");
    }
  }, [cmmScreenshotModalOpen]);

  const handleViewCmmClick = async (rowData: AestraPrimaryCareTable) => {
    setSelectedCmmRowData(rowData);
    setCmmScreenshotDownloadUrl(null);

    // Open modal immediately
    setCmmScreenshotModalOpen(true);
    setExternalLoading(true);

    // Fetch data asynchronously
    try {
      const cmmScreenshotPath = await getCmmScreenshotFilePath(
        rowData.identifier,
      );
      if (cmmScreenshotPath) {
        const downloadUrl = await getFileDownloadUrl(cmmScreenshotPath);
        setCmmScreenshotDownloadUrl(downloadUrl);
      }
    } catch (error) {
      console.error("Error fetching CMM screenshot:", error);
      setCmmScreenshotDownloadUrl(null);
    } finally {
      setExternalLoading(false);
    }
  };

  const closeCmmScreenshotModal = () => {
    setCmmScreenshotModalOpen(false);
  };

  return {
    cmmScreenshotDownloadUrl,
    cmmScreenshotModalOpen,
    selectedCmmRowData,
    handleViewCmmClick,
    closeCmmScreenshotModal,
    externalLoading,
  };
};
